import { useAppDispatch, useAppSelector } from "@/app/lib/features/redux/redux.hook";
import { useCallback } from "react";
import {
  getAiControl as getAiControlThunk,
  sendMessage as sendMessageThunk,
  getMessages as getMessagesThunk,
} from "./tozy.thunk";
import { resetTozy } from "./tozy.slice";
import { isLoading } from "@/app/utils/asyncStatus";
import { GetMessagesRequest, SendMessageRequest } from "./tozy.types";

const useTozy = () => {
  const dispatch = useAppDispatch();
  const { control, controlStatus, messages, pagination, messagesStatus, sendStatus, error } =
    useAppSelector((store) => store.tozy);

  const fetchControl = useCallback(() => {
    dispatch(getAiControlThunk());
  }, [dispatch]);

  const fetchMessages = useCallback(
    (params?: GetMessagesRequest) => dispatch(getMessagesThunk(params)),
    [dispatch],
  );

  const send = useCallback(
    async (data: SendMessageRequest) => {
      return dispatch(sendMessageThunk(data));
    },
    [dispatch],
  );

  const fetchMore = useCallback(() => {
    if (!pagination || pagination.current_page >= pagination.last_page) return;
    dispatch(getMessagesThunk({ per_page: 20, page: pagination.current_page + 1 }));
  }, [dispatch, pagination]);

  const reset = useCallback(() => dispatch(resetTozy()), [dispatch]);

  const hasMore = pagination
    ? pagination.current_page < pagination.last_page
    : false;

  return {
    control,
    isControlLoading: isLoading(controlStatus),
    messages,
    pagination,
    hasMore,
    isMessagesLoading: isLoading(messagesStatus),
    isSending: isLoading(sendStatus),
    error,
    fetchControl,
    fetchMessages,
    fetchMore,
    send,
    reset,
  };
};

export default useTozy;